import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModalComponent implements OnInit {
  public active: boolean = false;
  public title: string = '';
  public showReturn: boolean = true;
  public onClose!: Subject<boolean>;
  public redirecToHome: boolean = false;
  public constructor(private _bsModalRef: BsModalRef, private router: Router) {}

  public ngOnInit(): void {
    this.onClose = new Subject();
  }

  public showConfirmationModal(title: string): void {
    this.title = title;
    this.active = true;
    this.showReturn = true;
  }

  public onConfirm(): void {
    this.active = false;
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.active = false;
    this.onClose.next(false);
    this._bsModalRef.hide();
    if (this.redirecToHome == true) {
      return;
    } else {
      this.router.navigate(['/user-management/contractors']);
      return;
    }
  }

  public onReturn(): void {
    this.active = false;
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.active = false;
    this.onClose.next(false);
    this._bsModalRef.hide();
  }
}
